import { PaywallAuthErrorCodes, PremiumPaywallSignModes } from "../../../../../../global/paywall/paywallInterfaces";
import { LegalLink } from "../premiumCalcalistPaywallMobile";
import { HyperLinkBuilder } from "../../../../../commonComponents/inline/hyperLink"


interface PremiumPayWallMobileSignupEmailProps {
  email: string
  agreesTerms: boolean
  setEmail: (email: string) => void
  setAgreesTerms: (agreesTerms: boolean) => void
  setMode: (mode: PremiumPaywallSignModes) => void
  loginWithGoogle: () => void
  loginWithApple: () => void
  sendMail: () => void
  authError: string
  legalLinks: {terms: LegalLink; privacy: LegalLink};
  setAuthError?: (errorCode: PaywallAuthErrorCodes | null) => void;
}


const errorMessage: Partial<Record<PaywallAuthErrorCodes, string>> = {
  [PaywallAuthErrorCodes.INVALID_EMAIL]: 'כתובת דוא"ל אינה תקינה',
  [PaywallAuthErrorCodes.SIGNUP_NO_AGREEMENT]: `חובה לאשר את תנאי השימוש`,
  [PaywallAuthErrorCodes.EMAIL_ALREADY_EXISTS]: 'כתובת דוא"ל כבר קיימת במערכת',
  [PaywallAuthErrorCodes.ALREADY_SIGNED]: 'משתמש קיים במערכת',
  [PaywallAuthErrorCodes.INVALID_CELL_PHONE_NUMBER]: 'מספר טלפון אינו תקין',
  [PaywallAuthErrorCodes.FAILED_TO_SEND_OTP]: "אירעה שגיאה במערכת, אנא נסו שוב מאוחר יותר",
  [PaywallAuthErrorCodes.NOT_REGISTERED]: 'פרטי ההתחברות שהוזנו אינם נכונים',
  [PaywallAuthErrorCodes.OTP_MAX_ATTEMPTS]: "חרגת ממספר בקשות אימות. יש לפנות לשירות לקוחות",
}


export const PremiumPayWallMobileSignupEmail = (props: PremiumPayWallMobileSignupEmailProps) => {

  const { email, setEmail, agreesTerms, setAgreesTerms, loginWithApple, loginWithGoogle, setMode, sendMail, authError,legalLinks,setAuthError} = props

  const handleMailChange = (e) => {
    setEmail(e.target.value)
  }

  const handleAgreeChange = (e) => {
    setAgreesTerms(e.target.checked)
  }

  const handleSendMail = () => {
    sendMail()
  }

  const handlePressKey = (e) => {
    if (e.key === 'Enter') {
      handleSendMail()
    }
  }

    const handleEmailReset = () => {
    setEmail('');
    setAuthError(null);
  }

  return (
    <div className="premium-calcalist-paywall-mobile-signup-email">
      <div className="digital-edition-label">המהדורה הדיגיטלית</div>
      <p className="title">צרו חשבון חדש</p>
      <div className="subtitle">וקראו את המהדורה הדיגיטלית<span className='bold'>שבועיים מתנה!</span></div>
      <div className={`email-signup ${authError && authError.includes('EMAIL') ? 'error' : ''}`}>
        <input value={email} onKeyDown={handlePressKey} onChange={handleMailChange} type="email" placeholder="הקלידו כתובת מייל" />
        {email &&  <div className="reset-icon" onClick={handleEmailReset}></div> }
        {authError && authError === PaywallAuthErrorCodes.INVALID_EMAIL && <p className="error-text">{errorMessage[authError]}</p>}
      </div>
      <div className={`terms ${authError && authError === PaywallAuthErrorCodes.SIGNUP_NO_AGREEMENT ? 'error' : ''}`}>
        <div className="inner-container">
          <input type="checkbox" checked={agreesTerms} onChange={handleAgreeChange} />
          <span className="text">מסכים/ה ל<HyperLinkBuilder linkTarget={legalLinks.terms.target} href={legalLinks.terms.url}>תנאי השימוש</HyperLinkBuilder>, <HyperLinkBuilder linkTarget={legalLinks.privacy.target} href={legalLinks.privacy.url}>מדיניות פרטיות</HyperLinkBuilder>, וקבלת פניות שיווקיות כולל טלפוניות, הודעות תפעוליות ימשיכו להישלח בתקופת המנוי גם לאחר הסרתי מרשימת מדוורים</span>
        </div>
       {authError && authError === PaywallAuthErrorCodes.SIGNUP_NO_AGREEMENT && <p className="error-text" dangerouslySetInnerHTML={{ __html: errorMessage[authError] }}></p>}
      </div>

      <div className="buttons-container">
        <button className="button-base continue" onClick={handleSendMail}>המשך</button>
      </div>

      <div className="separator">
        <div className="register-logo"></div>
        <span className="text">או הירשמו באמצעות</span>
      </div>


      <div className="social-signup">
        <button className="social-button google-btn" onClick={loginWithGoogle}><span>גוגל</span></button>
        <button className="social-button apple-btn" onClick={loginWithApple}><span>אפל</span></button>
      </div>

      <div className="login">
        <div>כבר נרשמתם? <a href="#" onClick={() => setMode("signIn")}>כניסה</a></div>
      </div>
      <div className="newspapper-users" >
        <div><span>טרם נרשמתם אבל מנויים של</span> <span className="calcalist-label"></span>?</div>
        <div className="login"><a href="#" onClick={() => setMode("signIn")}>לחצו כאן להתחברות</a></div>
      </div>
    </div>
  )
}
